import { LandingTemplate } from "@/components/LandingTemplate";
import { IMG, FAQS } from "@/data/site";

const faqs = FAQS.filter((f) => f.c === "Business Travel" || f.c === "WiFi");

export default function BusinessTravel() {
  return (
    <LandingTemplate
      seo={{
        title: "Business Hotel in Ottawa, KS — Corporate & Government Travel",
        description: "A business-friendly hotel in Ottawa, Kansas off I-35. Free high-speed WiFi, in-room workspaces, express check-out and a 24-hour front desk for corporate travelers, contractors, government per-diem and sales reps.",
        path: "/business-travel",
        breadcrumbs: [{ name: "Home", path: "/" }, { name: "Business Travel", path: "/business-travel" }],
        faqs,
      }}
      kicker="Work Made Easy"
      heroTitle="Business Travel"
      heroLines={["Get in.", "Get rest.", "Get to work."]}
      heroImage={IMG.desk}
      intro="For the working traveler, the little things matter. Fast free WiFi, a real workspace, express check-out and a 24-hour front desk mean you can focus on the job — not the logistics. And direct booking keeps it simple for expense reports and per-diem."
      audiences={["Corporate travelers", "Government & per-diem", "Sales representatives", "Contractors", "Regional managers", "Engineers", "Utility companies", "Insurance adjusters", "Medical representatives", "Business meetings"]}
      features={[
        { icon: "Wifi", title: "Free High-Speed WiFi", desc: "Reliable internet for video calls, uploads and late-night work." },
        { icon: "Laptop", title: "In-Room Workspace", desc: "A proper desk and chair in a quiet, distraction-free room." },
        { icon: "Zap", title: "Express Check-out", desc: "Skip the front-desk line and hit the road on time." },
        { icon: "Clock", title: "24-Hour Front Desk", desc: "Arrive on the red-eye or leave before dawn — we're here." },
        { icon: "Truck", title: "Free Parking", desc: "Room for work trucks, vans and rental cars at no charge." },
        { icon: "Coffee", title: "Free Breakfast", desc: "Fuel up before your first meeting, on the house." },
      ]}
      bandImage={IMG.roomWide}
      bandTitle="Right by the highway"
      bandText="Located directly off I-35, we're a fast, predictable base for regional work — close to Ottawa's employers and industrial areas, and an easy drive to Lawrence and the Kansas City metro when the job takes you further."
      benefits={[
        "Free high-speed WiFi for video calls",
        "Dedicated in-room workspace",
        "Express check-out for early departures",
        "24-hour front desk & free parking",
        "Simple direct booking for expense reports",
        "Corporate & government rates — inquire by phone",
      ]}
      keywords={["Business hotel Ottawa KS", "Corporate hotel Ottawa Kansas", "Government per diem hotel Kansas", "Hotel for contractors Ottawa KS", "Hotel with workspace I-35", "Sales rep hotel Ottawa"]}
      faqs={faqs}
    />
  );
}
